module.exports = __webpack_public_path__ + "static/Impact_0_1-37777d74d136120bd6af6626c25bfc98.svg";